import { render, staticRenderFns } from "./instagram-star.vue?vue&type=template&id=616536cf&scoped=true"
import script from "./instagram-star.vue?vue&type=script&lang=js"
export * from "./instagram-star.vue?vue&type=script&lang=js"
import style0 from "./instagram-star.vue?vue&type=style&index=0&id=616536cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616536cf",
  null
  
)

export default component.exports